export function actionVerbForResource(renderType: string | null, behavior: string): string {
  if (renderType === "todo") return "";
  if (behavior === "redirect") return "Acessar";
  switch (renderType) {
    case "rich_doc":
    case "notion_mirror":
      return "Ler";
    case "process_steps":
    case "setup_checklist":
      return "Completar";
    case "tool_setup":
      return "Configurar";
    case "slack_channel_info":
      return "Entrar";
    case "todo":
      return "";
    default:
      return "Ler";
  }
}
